import IcProductCalendar from '@/assets/icons/ic-product-calendar.svg';
import IcProductCollectEmails from '@/assets/icons/ic-product-collect-emails.svg';
import IcProductCourse from '@/assets/icons/ic-product-course.svg';
import IcProductWebinar from '@/assets/icons/ic-product-webinar.svg';
import IcProductDownload from '@/assets/icons/ic-product-download.svg';
import IcProductMembership from '@/assets/icons/ic-product-membership.svg';
import IcProductCommunity from '@/assets/icons/ic-product-community.svg';
import IcProductURL from '@/assets/icons/ic-product-URL.svg';
import IcBox from '@/assets/icons/ic-box.svg';

export const PAGE_STATUS = {
    HIDDEN: 0,
    DRAFT: 1,
    PUBLISHED: 2,
} as const;

export const PAGE_LOCATION = {
    STORE: 'store',
    LANDING: 'landing',
} as const;

export const STORE_TABS = {
    DETAILS: 'details',
    LANDING_PAGES: 'landing-pages-tab',
    DESIGN: 'design',
} as const;

export const PAGE_TYPE_ICONS = {
    meeting: IcProductCalendar,
    'lead-magnet': IcProductCollectEmails,
    course: IcProductCourse,
    webinar: IcProductWebinar,
    'digital-download': IcProductDownload,
    membership: IcProductMembership,
    community: IcProductCommunity,
    link: IcProductURL,
    default: IcBox,
} as const;
